module.exports = __webpack_public_path__ + "static/media/13a71472f31f0ec3f38adcc0bfacf17e.e4d67e6d.png";